import React from 'react';
import { Container } from 'react-bootstrap';
import Tickets from '../Tickets/Tickets';

const Home = () => {
    return (
        <Container>
            <Tickets />
        </Container>
    );
};

export default Home;